import axios from 'axios';
import Constants from '../constants';
import { SurveyImage } from '../models';

export const surveyImageUrl = (surveyId: number) => {
	return Constants.API_SURVEY_IMAGE_URL.replace('{surveyId}', surveyId.toString());
};

export async function getSurveyImage(surveyId: number): Promise<SurveyImage | undefined> {
	const response = await axios.get<SurveyImage | undefined>(surveyImageUrl(surveyId), { headers: Constants.noCacheHeader });
	return response.status === 204 ? undefined : response.data;
}
